import { render, staticRenderFns } from "./WidgetTotalScore.vue?vue&type=template&id=22b79e84&"
import script from "./WidgetTotalScore.vue?vue&type=script&lang=js&"
export * from "./WidgetTotalScore.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTotalScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports